import { render, staticRenderFns } from "./mobile-floating-buttons.vue?vue&type=template&id=570cdfdd&scoped=true&"
import script from "./mobile-floating-buttons.vue?vue&type=script&lang=js&"
export * from "./mobile-floating-buttons.vue?vue&type=script&lang=js&"
import style0 from "./mobile-floating-buttons.vue?vue&type=style&index=0&id=570cdfdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570cdfdd",
  null
  
)

export default component.exports